import supabase from '../../supabase/supabase';

export const getLedger = async (kidId) => {
  const { data, error } = await supabase
    .from('ledger_20240320')
    .select('*')
    .eq('kid_id', kidId)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data;
};

export const addLedgerEntry = async (kidId, userId, amount, note) => {
  const { data, error } = await supabase
    .from('ledger_20240320')
    .insert({ kid_id: kidId, user_id: userId, amount, note })
    .select()
    .single();
  if (error) throw error;

  const { data: kid } = await supabase.from('kids_20240320').select('balance').eq('id', kidId).single();
  await supabase.from('kids_20240320').update({ balance: (Number(kid.balance) + amount) }).eq('id', kidId);

  return data;
};

export const editLedgerEntry = async (entryId, userId, newAmount, newNote) => {
  const { data: oldEntry, error: fetchError } = await supabase
    .from('ledger_20240320')
    .select('*')
    .eq('id', entryId)
    .single();
  if (fetchError) throw fetchError;

  // Insert to ledger edits history table
  await supabase.from('ledger_edits_20240320').insert({
    entry_id: entryId,
    old_amount: oldEntry.amount,
    old_note: oldEntry.note,
    edited_by: userId
  });

  const { error: updateError } = await supabase
    .from('ledger_20240320')
    .update({ amount: newAmount, note: newNote, edited_at: new Date().toISOString() })
    .eq('id', entryId);
  if (updateError) throw updateError;

  const diff = newAmount - oldEntry.amount;
  const { data: kid } = await supabase.from('kids_20240320').select('balance').eq('id', oldEntry.kid_id).single();
  await supabase.from('kids_20240320').update({ balance: (Number(kid.balance) + diff) }).eq('id', oldEntry.kid_id);
};

export const getLedgerEdits = async (entryId) => {
  const { data, error } = await supabase
    .from('ledger_edits_20240320')
    .select('*')
    .eq('entry_id', entryId)
    .order('edited_at', { ascending: false });
  if (error) throw error;
  return data;
};